// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d05485a57c32d9255470","303":"77ad4d0bffaabab90c00","495":"4efa00b416f0c53cf118"}[chunkId] + ".js";
};